<script lang="ts">
  import { toOrdinal } from '$lib/utils/helpers';
  import type { PopeProgress } from '$lib/types';
  
  export let preceding: PopeProgress[] = [];
  export let following: PopeProgress[] = [];
  export let progress: number;
  export let rank: number;
</script>

<div id="progresslist">
  {#each preceding as pope}
    <div class="pope {pope.className}">
      <img src={pope.badgeFile} alt={pope.englishName} />
      <b>{pope.englishName}</b>
      <span>{pope.difference}</span>
      <span class="rank">{toOrdinal(pope.rank)}</span>
    </div>
  {/each}
  
  <div class="pope">
    <div id="you">
      <div id="inner">
        {progress}%
        <span class="small">outlived</span>
      </div>
    </div>
    <b>You</b>
    <span>Ranking:</span>
    <span class="rank">{toOrdinal(rank)}</span>
  </div>
  
  {#each following as pope}
    <div class="pope {pope.className}">
      <img src={pope.badgeFile} alt={pope.englishName} />
      <b>{pope.englishName}</b>
      <span>{pope.difference}</span>
      <span class="rank">{toOrdinal(pope.rank)}</span>
    </div>
  {/each}
</div>

<style>
  #progresslist {
    margin-top: 2em;
    padding-top: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0;
  }

  .pope {
    padding: 0 10px;
    text-align: center;
    flex: 0 0 auto;
  }

  .pope img {
    display: block;
    margin: 0 auto;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    filter: drop-shadow(0 0 0.25rem #222222);
  }

  #you {
    background: #00aa00;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    filter: drop-shadow(0 0 0.25rem #444444);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  #inner {
    padding-top: 4px;
    color: #ffffff;
    font-size: 34px;
    vertical-align: middle;
    line-height: 0.9em;
    margin: 0 auto;
    text-align: center;
  }

  #inner span {
    color: #ffffff;
    display: block;
    margin-top: -2px;
    font-size: 0.5em;
    line-height: 1em;
  }

  .pope b {
    display: block;
  }

  .pope > span {
    line-height: 0.85em;
    display: block;
    font-size: 0.7em;
    color: #888888;
    margin-bottom: 0.5em;
  }

  .pope > span.rank {
    font-weight: bold;
    color: #000;
  }

  :global(.fade1) {
    opacity: 0.75;
  }

  :global(.fade2) {
    opacity: 0.5;
  }

  :global(.fade3) {
    opacity: 0.25;
  }

  @media screen and (max-width: 1680px) {
    :global(.fade3) {
      display: none;
    }
  }

  @media screen and (max-width: 980px) {
    :global(.fade2) {
      display: none;
    }
  }

  @media screen and (max-width: 736px) {
    :global(.fade1) {
      display: none;
    }
  }
</style>
